import {createAsyncAction, createAction} from 'typesafe-actions';
import { CreateRequest } from '../../../api/medAppApi';
import { Model, ModelName} from '../../../models';

export const getDashboardAction = createAsyncAction(
    'MED_APP/ADMIN/GET_DASHBOARD/REQUEST',
    'MED_APP/ADMIN/GET_DASHBOARD/SUCCESS',
    'MED_APP/ADMIN/GET_DASHBOARD/FAIL',
)<never,  {
    Scheduled: number;
    Cancelled: number;
    Pending: number;
    Completed: number;
  }, 
  any>();

  export const getUnverifiedPhysicansAction = createAsyncAction(
    'MED_APP/ADMIN/GET_UNVERIFIED_PHYSICIANS/REQUEST',
    'MED_APP/ADMIN/GET_UNVERIFIED_PHYSICIANS/SUCCESS',
    'MED_APP/ADMIN/GET_UNVERIFIED_PHYSICIANS/FAIL',
)<void, number, string>();

export const loadUnverifiedPhysicians = createAction(
  'MED_APP/ADMIN/LOAD_UNVERIFIED_PHYSICIANS',
)<number>();

export const createModel = createAction(
  'MED_APP/ADMIN/CREATE_MODEL',
)<{model: Record<string, any>, modelName: ModelName, mapFunc?: (v: any) => any}>();

export const createModelRequest = createAsyncAction(
  'MED_APP/ADMIN/CREATE_MODEL/REQUEST',
  'MED_APP/ADMIN/CREATE_MODEL/SUCCESS',
  'MED_APP/ADMIN/CREATE_MODEL/FAIL',
)<CreateRequest,{model: Model, modelName: ModelName}, {modelName: ModelName, error?: any}>();

export const getLgas = createAsyncAction(
  'MED_APP/ADMIN/GET_LGAS/REQUEST',
  'MED_APP/ADMIN/GET_LGAS/SUCCESS',
  'MED_APP/ADMIN/GET_LGAS/FAIL',
)<void, Array<{label: string; value: string;}>, string>();
